"use client";
import { useRouter } from "next/navigation";
import { c } from "@/lib/vster/theme";
import Icon from "@/components/vster/Icon";

// 상세 → 목록: 이전 화면으로 돌아가기(필터 유지). 히스토리가 없으면 /programs 로 폴백.
export default function BackToListButton() {
  const router = useRouter();
  const goBack = () => {
    if (typeof window !== "undefined" && window.history.length > 1) router.back();
    else router.push("/programs" as never);
  };
  return (
    <button
      type="button"
      onClick={goBack}
      style={{
        display: "inline-flex", alignItems: "center", gap: 7, background: c.surface,
        border: `1px solid ${c.line}`, color: c.ink, padding: "12px 24px", borderRadius: 10,
        fontSize: 14.5, fontWeight: 700, cursor: "pointer", fontFamily: "inherit",
      }}
    >
      <Icon name="arrow_back" size={18} color={c.ink} />목록으로
    </button>
  );
}
